import loadable from '@loadable/component';

export const WeWantToPayCTA = loadable(() =>
  import(/* webpackChunkName: "WeWantToPayCTA" */ './containers/CTA'),
);

export const WeWantToPayModal = loadable(() =>
  import(/* webpackChunkName: "WeWantToPayModal" */ './containers/Modal'),
);
